import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseUrlHelperService } from '../helper/baseUrlHelper.service';
import { Observable, throwError } from 'rxjs';
import { NbcLoggerService } from '../logger/nbc-logger.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {
  constructor(private http: HttpClient,
    private _apiroot: BaseUrlHelperService,
    private log: NbcLoggerService) { }



  public getOnboardingMasterData(): Observable<any> {
    this.log.trace("save onboarding Details");
    return this.http.get(this._apiroot.baseUrl + "onboarding/MasterData").pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  };


  public saveOnboardingPositionRequests(positionRequest: any): Observable<any> {
    this.log.trace("save onboarding Details");
    return this.http.post(this._apiroot.baseUrl + "onboarding/saveOnboarding", positionRequest).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  };

  public updateOnboardingPositionRequest(positionRequest: any): Observable<any> {
    this.log.trace("update onboarding Details");
    return this.http.post(this._apiroot.baseUrl + "onboardingrequest/updatePositionRequest", positionRequest).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  };

  public cancelOnboardingRequests(positionRequest: any): Observable<any> {
    this.log.trace("cance onboarding Details");
    return this.http.post(this._apiroot.baseUrl + "onboardingrequest/cancelOnboardingRequest", positionRequest).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  };


  getTalentOnboardingCount(businessUnitId: any): Observable<any> {
    this.log.trace("get hr Talent count");
    return this.http.get(this._apiroot.baseUrl + "onboardingrequest/headerTemplateCount/" + businessUnitId).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  };

  public getOnboardingDashboardMasterData(requestType: any): Observable<any> {
    this.log.trace("save onboarding Details");
    return this.http.get(this._apiroot.baseUrl + "onboardingrequest/DashboardMasterData/" + requestType).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  };

  search(hrOnboardingQuery: any, requestType: any): Observable<any> {
    return this.http.post(this._apiroot.baseUrl + "onboardingrequest/search/" + requestType , hrOnboardingQuery).pipe(
      catchError((err) => {
        return throwError(err);
      })
    )
  };

  getSFModalURL(modalSharedResource: any, businessUnitId: any): Observable<any> {
    this.log.trace("call getsfmodal");
    return this.http.post(this._apiroot.baseUrl + "onboardingrequest/getsfmodal/" + businessUnitId , modalSharedResource).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getPositionRequestInfo(crewRegistrationNo: any, contactId: any, requestId: any, positionRequestInfo: any): Observable<any> {
    this.log.trace("get onboarding single request Details");
    console.log("get onboarding single request Details");
    return this.http.post(this._apiroot.baseUrl + "onboardingrequest/getPositionRequestInfo/" + crewRegistrationNo + "/" + contactId + "/" + requestId, positionRequestInfo).pipe(
      catchError((err) => {
        console.log("NOT NESTED Method");
        console.log(err);
        return throwError(err);
      })
    );
  };

  update(registrationObject: any): Observable<any> {
    return this.http.post(this._apiroot.baseUrl + "onboardingrequest/update/SapNo", registrationObject).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  };

  updateI9VerifyReason(registrationObject: any): Observable<any> {
    return this.http.post(this._apiroot.baseUrl + "onboardingrequest/update/I9VerifyReason", registrationObject).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  };

  updateTafSubmittedFlag(registrationObject: any): Observable<any> {
    return this.http.post(this._apiroot.baseUrl + "onboardingrequest/update/TafSubmittedFlag", registrationObject).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  };
    
}
